import React from 'react';
import { Provider } from 'react-redux';

import SiteMap from '../routes/routes';

export default ({ store }) => (
  <Provider store={store}>
    <SiteMap store={store}/>
  </Provider>
);



// WEBPACK FOOTER //
// ./book/src/commons/components/Root.prod.jsx